import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { CURRENT_APPLICATION } from "../../store/application-getters";
import { defineComponent } from "@vue/composition-api";
import ApplicationLockModal from "./application-lock-modal.vue";
export default defineComponent({
  name: "ApplicationLockButton",
  components: {
    ApplicationLockModal
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), {}, {
    locked() {
      return this.CURRENT_APPLICATION.locked;
    },
    title() {
      const {
        locked
      } = this;
      return locked ? this.$t("application.messages.applicationIsLocked") : this.$t("application.messages.applicationIsUnlocked");
    },
    iconClass() {
      const className = [];
      if (this.locked) className.push("fa-lock");else className.push("fa-unlock");
      return className.join(" ");
    }
  }),
  methods: {
    handleClick() {
      this.$refs.lockModal.$showModal();
    }
  }
});